import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { Address, CustomerAddressType } from "../../Models/Account/Address";
import { CustomerShippingInfo, ShippingStatus } from "../../Models/Shipping/CustomerShippingInfo";

@ModuleName("Shipping")
export class Shipping implements AxInit {
    private AddressFormSelector: string = "form[name=shipping_portlet__address_form]";
    private InvoiceFormSelector: string = "form[name=shipping_portlet__invoice_form]";

    private AddressModalSelector: string = ".shipping_portlet__address_modal";
    private InvoiceModalSelector: string = ".shipping_portlet__invoice_modal";

    private Addresses: Address[];
    private ShippingInfo: CustomerShippingInfo;

    constructor(private _AxLimestone = new AxLimeStone()) { }

    AxInit(init: ShippingInitData): void {
        this.Addresses = init.Addresses;
        this.ShippingInfo = init.ShippingInfo;

        $(`input[name=shipping_portlet__type][value=${this.ShippingInfo.Status}]`).prop('checked', true);

        this.ShippingEditEvents();
        this.ShippingChangeEvents();
        this.AddresseDeleteEvents();
        this.toggleShippingFee();
        this.SubmitEvents();
    }


    SubmitEvents() {
        $('.shipping_submit').click(x => {
            let target = x.delegateTarget;
            this._AxLimestone.LockButton(target);

            AxessViewer.loadPartialView("/Shipping/Checkout", {}, resp => {
                if (resp.success) {
                    window.location.href = resp.successLink;
                } else {
                    Swal.fire({
                        text: resp.message,
                        icon: 'info',
                    }).then((result) => {
                        this._AxLimestone.UnlockButton(target);
                    });
                }

            }, { silent: true });
        });
    }


    ShippingChangeEvents() {
        $('input[name=shipping_portlet__type]').change(x => {
            this.ShippingInfo.Status = parseInt($(x.delegateTarget).val() as string);
            this.toggleShippingFee();
            this.SaveShippingInfo();
        });

        $(`${this.AddressModalSelector} .shipping_address_change`).click(x => {
            let typeID = parseInt($(x.delegateTarget).attr('data-type'));
            this.ShippingInfo.DeliveryAddress = typeID;

            this.UpdateCurrentShipping(this.AddressModalSelector, typeID, '.shipping_address__current_del');
            this.SaveShippingInfo();
        });

        $(`${this.InvoiceModalSelector} .shipping_address_change`).click(x => {
            let typeID = parseInt($(x.delegateTarget).attr('data-type'));
            this.ShippingInfo.InvoiceAddress = typeID;

            this.UpdateCurrentShipping(this.InvoiceModalSelector, typeID, '.shipping_address__current_inv');
            this.SaveShippingInfo();
        });
    }

    toggleShippingFee() {
        $('.shipping_price-incFee').toggleClass('d-none', this.ShippingInfo.Status === ShippingStatus.PickUp);
        $('.shipping_price-excFee').toggleClass('d-none', this.ShippingInfo.Status !== ShippingStatus.PickUp);
    }

    AddresseDeleteEvents() {
        $('.shipping_address_delete').click(x => {
            let typeID = parseInt($(x.delegateTarget).attr('data-type'));
            let data = this.Addresses.find(x => x.Type == typeID) as AddressEdit;
            data.Delete = true;

            AxessViewer.loadPartialView("/Shipping/EditAddress", data, x => {
                $('.shipping_portlet__address_modal').modal('hide');
            }, { reload: true });
        });
    }

    ShippingEditEvents() {
        $('.shipping_portlet__address_edit').click(x => {
            $(this.AddressModalSelector).modal('show');
        });
        $('.shipping_portlet__invoice_edit').click(x => {
            $(this.InvoiceModalSelector).modal('show');
        });


        $(`${this.AddressModalSelector} .shipping_address_edit`).click(x => {
            let typeID = parseInt($(x.delegateTarget).attr('data-type'));
            this.FillAddressForm(this.AddressModalSelector, this.AddressFormSelector, this.Addresses.find(x => x.Type == typeID));
        });
        $(`${this.InvoiceModalSelector} .shipping_address_edit`).click(x => {
            let typeID = parseInt($(x.delegateTarget).attr('data-type'));
            this.FillAddressForm(this.InvoiceModalSelector, this.InvoiceFormSelector, this.Addresses.find(x => x.Type == typeID));
        });

        $(`${this.AddressModalSelector} .shipping_address_add`).click(x => {
            let typeID = parseInt($(x.delegateTarget).attr('data-type'));
            this.EmptyAddressForm(this.AddressModalSelector, this.AddressFormSelector, typeID);
        });
        $(`${this.InvoiceModalSelector} .shipping_address_add`).click(x => {
            let typeID = parseInt($(x.delegateTarget).attr('data-type'));
            this.EmptyAddressForm(this.InvoiceModalSelector, this.InvoiceFormSelector, typeID);
        });

        $(`${this.AddressModalSelector} .address_form__submit`).click(x => {
            let data = $(`${this.AddressModalSelector} ${this.AddressFormSelector}`).serialize();
            AxessViewer.loadPartialView("/Shipping/EditAddress", data, x => {
                $(this.AddressModalSelector).modal('hide');
            }, { reload: true });
        });

        $(`${this.InvoiceModalSelector} .address_form__submit`).click(x => {
            let data = $(`${this.InvoiceModalSelector} ${this.InvoiceFormSelector}`).serialize();
            AxessViewer.loadPartialView("/Shipping/EditAddress", data, x => {
                $(this.InvoiceModalSelector).modal('hide');
            }, { reload: true });
        });

        $(`${this.AddressModalSelector} .address_form__cancel`).click(x => {
            $(`${this.AddressModalSelector} .shipping_address_edit_form`).addClass('d-none');
            $(`${this.AddressModalSelector} .shipping_address_list`).removeClass('d-none');
        });

        $(`${this.InvoiceModalSelector} .address_form__cancel`).click(x => {
            $(`${this.InvoiceModalSelector} .shipping_address_edit_form`).addClass('d-none');
            $(`${this.InvoiceModalSelector} .shipping_address_list`).removeClass('d-none');
        });
    }

    SaveShippingInfo() {
        AxessViewer.loadPartialView("/Shipping/UpdateShippingInfo", this.ShippingInfo, y => {
        }, { silent: true });
    }

    UpdateCurrentShipping(modalSelector: string, type: CustomerAddressType, additionalSelector: string) {
        let address = $(`${modalSelector} .shipping_address[data-for=${type}]`).clone();
        $(`${modalSelector} .shipping_address__current, ${additionalSelector}`).html(address.html());
    }

    EmptyAddressForm(modalSelector: string, formSelector: string, type: CustomerAddressType) {
        $(`${modalSelector} ${formSelector} [name="Type"]`).val(type);
        $(`${modalSelector} ${formSelector} [name="Street"]`).val('');
        $(`${modalSelector} ${formSelector} [name="Description"]`).val('');
        $(`${modalSelector} ${formSelector} [name="City"]`).val('');
        $(`${modalSelector} ${formSelector} [name="ZipCode"]`).val('');
        $(`${modalSelector} ${formSelector} [name="CO"]`).val('');
        $(`${modalSelector} ${formSelector} [name="State"]`).val('');
        $(`${modalSelector} ${formSelector} [name="CountryCode"]`).val('');

        $(`${modalSelector} .shipping_address_list`).addClass('d-none');
        $(`${modalSelector} .shipping_address_edit_form`).removeClass('d-none');
    }

    FillAddressForm(modalSelector: string, formSelector: string, address: Address) {
        $(`${modalSelector} ${formSelector} [name="Type"]`).val(address.Type);
        $(`${modalSelector} ${formSelector} [name="Street"]`).val(address.Street);
        $(`${modalSelector} ${formSelector} [name="Description"]`).val(address.Description);
        $(`${modalSelector} ${formSelector} [name="City"]`).val(address.City);
        $(`${modalSelector} ${formSelector} [name="ZipCode"]`).val(address.ZipCode);
        $(`${modalSelector} ${formSelector} [name="CO"]`).val(address.CO);
        $(`${modalSelector} ${formSelector} [name="State"]`).val(address.State);
        $(`${modalSelector} ${formSelector} [name="CountryCode"]`).val(address.CountryCode);

        $(`${modalSelector} .shipping_address_list`).addClass('d-none');
        $(`${modalSelector} .shipping_address_edit_form`).removeClass('d-none');
    }
}


class ShippingInitData {
    Addresses: Address[];
    ShippingInfo: CustomerShippingInfo;
}

class AddressEdit implements Address {
    City: string;
    CO: string;
    CountryCode: string;
    Description: string;
    Phone: string;
    Street: string;
    ZipCode: string;
    State: string;
    Type: CustomerAddressType;

    Delete: boolean;
}